import { FontFamily } from './fontFamily/fontFamily';
import { StringHelper } from '@/helper/stringHelper';

export interface LocalFontParams {
    fontFilename: string;
    name: string;
    family: string;
    localizedName: string;
    enName: string;
    style?: string;
    weight?: number;
    italic?: boolean;
}

export default class LocalFont {
    public readonly name: string;
    public readonly family: string;
    public readonly fullName : string;
    public readonly localizedName: string;
    public readonly style: string = 'Regular';
    public readonly weight: number = 400;
    public readonly italic: boolean = false;
    public readonly displayName: string = '';
    public readonly enFamily: string;
    public readonly optionalFontName: string = '';    // optional

    public constructor(params: LocalFontParams) {
        this.name = params.name;
        this.family = params.family;
        this.localizedName = params.localizedName;
        this.style = params.style || this.style;
        this.weight = params.weight || this.weight;
        this.italic = params.italic || this.italic;
        this.displayName = this.createDisplayName(params.fontFilename, params.localizedName || params.family, params.style || this.style);
        this.enFamily = this.createEnFamilyName(params.enName || "");
        this.fullName = this.createFullName(params.localizedName || "");
        this.optionalFontName = this.createOptionalFontName(this.displayName);
    }

    public toFont(): FontFamily {
        var font = new FontFamily(this.name, 1, this.displayName, this.fullName, this.displayName, this.family, this.enFamily, 'sans-serif', this.family, this.family, this.weight, true);
        font.isLocalFont = true;
        font.optionalFontName = this.optionalFontName;
        return font;
    }

    private createDisplayName(basename: string, family: string, style: string): string {
        if(style == "Regular" || style == "標準" || style == "レギュラー")
        {
            // スタイルは除く
            return `${family}`;
        }
        else
        {
            return `${family} ${style}`;
        }
        // if (StringHelper.isHankaku(basename)) {
        //     // ファイル名も英語なら正式なファミリー名の方を使う
        //     return `${family} ${style}`;
        // } else {
        //     if (basename.endsWith(style)) {
        //         // styleがすでに含まれている場合は無視する
        //         return basename;
        //     } else {
        //         return `${basename} ${style}`;
        //     }
        // }
    }

    private createFullName(name : string)
    {
        const prefix = "AR";
        if(name.startsWith(prefix))
        {
            // ARフォントの対応
            // 最後が "M" "L" "H"で終わるフォントが表示されないのを対応
            return this.removeSuffixIfNeeded(name, ["M", "L", "H", "B", "E", "U"]);
        }
        else if(name.startsWith("A-OTF"))
        {
            // A-OTF 解ミンフォントの対応
            return this.removeSuffixIfNeeded(name, [" R", " M", " B", " H"]);
        }
        return name;
    }

    private removeSuffixIfNeeded(orgname : string, suffixArray : Array<string>)
    {
        for(let suffix of suffixArray)
        {
            if(orgname.endsWith(suffix))
            {
                return orgname.substr(0, orgname.length - suffix.length);
            }
        }
        return orgname;
    }

    private createOptionalFontName(displayName : string)
    {
        // 小塚ゴシック対応
        if(displayName.startsWith("小塚ゴシック Pr6N"))
        {
            if(displayName.endsWith(" EL"))
                return "KozGoPr6N-ExtraLight";
            else if(displayName.endsWith(" L"))
                return "KozGoPr6N-Light";
        }
        if(displayName.startsWith("小塚ゴシック Pro"))
        {
            if(displayName.endsWith(" EL"))
                return "KozGoPro-ExtraLight";
            else if(displayName.endsWith(" L"))
                return "KozGoPro-Light";
        }
        if(displayName.startsWith("小塚明朝 Pr6N"))
        {
            if(displayName.endsWith(" EL"))
                return "KozMinPr6N-ExtraLight";
            else if(displayName.endsWith(" L"))
                return "KozMinPr6N-Light";
        }
        if(displayName.startsWith("小塚明朝 Pro"))
        {
            if(displayName.endsWith(" EL"))
                return "KozMinPro-ExtraLight";
            else if(displayName.endsWith(" L"))
                return "KozMinPro-Light";
        }
        return "";
    }

    private createEnFamilyName(name : string)
    {
        // スタイル文字列を削除する
        // ARフォントなどに対応
        const styles = [
            "Extra Light",
            "ExtraLight",
            "Extralight",
            "Ultra Light",
            "UltraLight",
            "Ultralight",
            "Semi Light",
            "SemiLight",
            "Semilight",
            "Sami Bold",
            "SemiBold",
            "Semibold",
            "Demi Bold",
            "DemiBold",
            "Demibold",
            "Extra Bold",
            "ExtraBold",
            "Extrabold",
            "Ultra Bold",
            "UltraBold",
            "Ultrabold",
            "Extra Black",
            "ExtraBlack",
            "Extrablack",
            "Ultra Black",
            "UltraBlack",
            "Ultrablack",
            "Super Bold",
            "SuperBold",
            "Superbold",
            "Thin",
            "Hairline",
            "Light",
            "Normal",
            "Regular",
            "Medium",
            "Bold",
            "Black",
            "Heavy4",
            "Heavy",
            "Ultra",
            "Extra"
        ];
        for (let style of styles) {
            // 最後から文字列一致をする
            let newName = StringHelper.replaceLast(name, " " + style, "");
            if(newName != name)
            {
                return newName;
            }
        }

        return name;
    }
}
